// API keys page — admin-only. Generated key is shown ONCE and never again.

(function ($) {
  'use strict';

  if ($('#apikey-tbody').length === 0) return;

  var BTN_PRIMARY = 'bg-orange-500 hover:bg-orange-600 text-white';
  var BTN_DANGER  = 'bg-red-500 hover:bg-red-600 text-white';

  function readForm() {
    return {
      name: $('#apikey-name').val().trim(),
      owner_id: $('#apikey-owner_id').val(),
      expires_in: $('#apikey-expires_in').val(),
    };
  }

  function patchRow($row, fields) {
    if (fields.status !== undefined) {
      var $cell = $row.find('.row-status');
      var s = fields.status;
      var cls = s === 'Active'
        ? 'bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300'
        : (s === 'Expired'
          ? 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/40 dark:text-yellow-300'
          : 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300');
      $cell.html('<span class="inline-block px-2 py-0.5 rounded text-xs ' + cls + '">' + s + '</span>');
      if (s !== 'Active') $row.find('.apikey-revoke-btn').remove();
    }
    if (fields.last_used_at !== undefined) {
      $row.find('.row-last_used_at').text(fields.last_used_at);
    }
  }

  function createdKeyView(rawKey, name) {
    return (
      '<div class="space-y-3">' +
        '<div class="flex items-start gap-2 p-3 rounded ' +
        'bg-yellow-50 border border-yellow-300 text-yellow-800 ' +
        'dark:bg-yellow-900/30 dark:border-yellow-700 dark:text-yellow-200 text-sm">' +
          '<i class="bi bi-exclamation-triangle-fill mt-0.5"></i>' +
          '<div>This is the only time the full key will be shown. Copy it now and store it somewhere safe.</div>' +
        '</div>' +
        '<div>' +
          '<label class="block text-sm mb-1">' + $('<div>').text(name).html() + '</label>' +
          '<div class="flex gap-2">' +
            '<input id="apikey-raw" type="text" readonly value="' + $('<div>').text(rawKey).html() + '" ' +
              'class="flex-1 px-3 py-2 rounded border border-slate-300 bg-slate-50 text-slate-900 font-mono text-xs ' +
              'dark:bg-slate-900 dark:border-slate-600 dark:text-slate-100 focus:outline-none">' +
            '<button id="apikey-copy" class="px-3 py-2 rounded bg-orange-500 hover:bg-orange-600 text-white text-sm">' +
              '<i class="bi bi-clipboard"></i> Copy' +
            '</button>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  // ---------- Add ----------
  $(document).on('click', '.apikey-add-btn', function () {
    $.get('/api/api-keys/modal/add/', function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      var dlg = new Dialog('Create API key', resp.html, { size: 'md' });
      dlg.setButtons([
        { name: 'Cancel', dismiss: true },
        {
          name: 'Generate',
          class: BTN_PRIMARY,
          onClick: function () {
            var lb = new LoadingButton(this); lb.start();
            $.post('/api/api-keys/add/', readForm())
              .done(function (r) {
                if (r.ok) {
                  $('#apikey-tbody').prepend(r.row_html);
                  // Replace dialog body with the one-time key view.
                  // The dialog body is the second child of the modal element.
                  if (dlg.modal && dlg.modal.children.length >= 2) {
                    dlg.modal.children[1].innerHTML = createdKeyView(r.raw_key, r.name);
                  }
                  // Replace buttons: only "Done" remains.
                  if (dlg.modal && dlg.modal.children.length >= 3) {
                    var footer = dlg.modal.children[2];
                    footer.innerHTML = '';
                    var done = document.createElement('button');
                    done.type = 'button';
                    done.className = 'rounded-md px-4 py-1.5 text-sm font-semibold ' + BTN_PRIMARY;
                    done.textContent = 'Done';
                    done.addEventListener('click', function () { dlg.hide(); });
                    footer.appendChild(done);
                  }
                  Toast.show('Key created', 'success');
                } else { Toast.show(r.error || 'Failed', 'error'); lb.stop('Generate'); }
              })
              .fail(function (xhr) {
                Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Request failed', 'error');
                lb.stop('Generate');
              });
          },
        },
      ]).show();
    });
  });

  // Copy-to-clipboard for the one-time key view.
  $(document).on('click', '#apikey-copy', function () {
    var $input = $('#apikey-raw');
    $input[0].select();
    try {
      document.execCommand('copy');
      if (navigator.clipboard) navigator.clipboard.writeText($input.val());
      Toast.show('Copied to clipboard', 'success');
    } catch (e) {
      Toast.show('Copy failed — select and copy manually', 'error');
    }
  });

  // ---------- Revoke ----------
  $(document).on('click', '.apikey-revoke-btn', function () {
    var $row = $(this).closest('tr');
    var id = $row.data('id');
    $.get('/api/api-keys/modal/revoke/', { id: id }, function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      var dlg = new Dialog('Revoke API key', resp.html, { size: 'sm' });
      dlg.setButtons([
        { name: 'Cancel', dismiss: true },
        {
          name: 'Revoke',
          class: BTN_DANGER,
          onClick: function () {
            var lb = new LoadingButton(this); lb.start();
            $.post('/api/api-keys/' + id + '/revoke/')
              .done(function (r) {
                if (r.ok) {
                  patchRow($row, r.fields);
                  Toast.show('Key revoked', 'success');
                  dlg.hide();
                } else { Toast.show(r.error || 'Failed', 'error'); lb.stop('Revoke'); }
              })
              .fail(function (xhr) {
                Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Request failed', 'error');
                lb.stop('Revoke');
              });
          },
        },
      ]).show();
    });
  });

  // ---------- Delete ----------
  $(document).on('click', '.apikey-delete-btn', function () {
    var $row = $(this).closest('tr');
    var id = $row.data('id');
    $.get('/api/api-keys/modal/delete/', { id: id }, function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      var dlg = new Dialog('Delete API key', resp.html, { size: 'sm' });
      dlg.setButtons([
        { name: 'Cancel', dismiss: true },
        {
          name: 'Delete',
          class: BTN_DANGER,
          onClick: function () {
            var lb = new LoadingButton(this); lb.start();
            $.post('/api/api-keys/' + id + '/delete/')
              .done(function (r) {
                if (r.ok) {
                  $row.remove();
                  Toast.show('Key deleted', 'success');
                  dlg.hide();
                } else { Toast.show(r.error || 'Failed', 'error'); lb.stop('Delete'); }
              })
              .fail(function (xhr) {
                Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Request failed', 'error');
                lb.stop('Delete');
              });
          },
        },
      ]).show();
    });
  });

})(jQuery);
